import { referAFriendApi } from '@/api/admin/refer-a-friend';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { IReferAFriendInitialState, IThunkAPI } from '../../types';
import { ICreateGigReferClass, IGigReferAFriendClass, IGigReferFriend } from '@/store/admin/types/types';

export const initialState: IReferAFriendInitialState = {
  payRates: undefined,
  gigReferFriendList: undefined,
};

// get pay rates
export const getPayRates = createAsyncThunk<any, void, IThunkAPI>('referAFriend/payRates', async (_, thunkAPI) => {
  try {
    const response = await referAFriendApi.getReferFriendPayRates();

    return response.data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

export const getGigReferFriend = createAsyncThunk<Array<IGigReferFriend>, IGigReferAFriendClass, IThunkAPI>(
  'referAFriend/list',
  async (formValues, thunkAPI) => {
    try {
      const response = await referAFriendApi.getGigReferFriendList(formValues);
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const createGigReferFriendList = createAsyncThunk<boolean, ICreateGigReferClass[], IThunkAPI>(
  'referAFriend/create',
  async (formValues, thunkAPI) => {
    try {
      const response = await referAFriendApi.createFeaturedGig(formValues);

      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const deleteGigReferFriendList = createAsyncThunk<boolean, ICreateGigReferClass, IThunkAPI>(
  'referAFriend/delete',
  async (formValues, thunkAPI) => {
    try {
      const response = await referAFriendApi.deleteFeaturedGig(formValues);

      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const referAFriendSlice = createSlice({
  name: 'referAFriendSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPayRates.fulfilled, (state, action) => {
        state.payRates = action.payload.result;
      })
      .addCase(getGigReferFriend.fulfilled, (state, action) => {
        state.gigReferFriendList = action.payload;
      });
  },
});

export default referAFriendSlice.reducer;
